<template>
  <footer class="fixed-footer">
    <div class="fixed-footer__container">
      <nuxt-link
        v-for="(item, itemIndex) in footerNavigation"
        :key="itemIndex"
        class="fixed-footer__item"
        :to="{ name: item.name }"
      >
        <i
          :class="item.icon"
          class="fixed-footer__icon"
        />
        <span class="fixed-footer__text">{{ item.text }}</span>
      </nuxt-link>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      footerNavigation: [
        {
          icon: 'icon-home',
          text: '首頁',
          name: 'home'
        },
        {
          icon: 'icon-bullet',
          text: '全部分類',
          name: 'serviceList'
        },
        {
          icon: 'icon-order',
          text: '訂單記錄',
          name: 'member-orderList'
        },
        {
          icon: 'icon-user',
          text: '會員中心',
          name: 'member-accountSetting'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;

  &__container {
    padding: 12px 30px;
    background-color: $color-background-secondary;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 -2px 16px 0 rgba(0, 0, 0, 0.1);
    padding-bottom: calc(12px + var(--safe-area-inset-bottom));
  }
  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    color: $color-caption;
    text-decoration: none;
    &:hover {
      color: $color-primary;
    }
  }
  &__icon {
    font-size: 24px;
    margin-bottom: 4px;
    color: $color-caption;
  }
  &__text {
    font-size: 11px;
    text-align: center;
    font-weight: 600;
  }
}
.nuxt-link-active {
  .fixed-footer__icon,
  .fixed-footer__text {
    color: $color-primary;
  }
}
</style>
